module.exports = __webpack_public_path__ + "img/peixun3.283d7d5c.png";